const INTERNAL_TRAFFIC_KEY = 'odysseyai.analytics.internal.v1';
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);
let internalForPage = false;

// This is a measurement label, never an authentication or authorization signal.
// Unmarked traffic is deliberately "unclassified", not "verified stranger".
export const getAnalyticsTrafficType = (browser = typeof window === 'undefined' ? null : window) => {
  if (!browser?.location) return 'unclassified';
  const query = new URLSearchParams(browser.location.search || '');
  const marker = query.get('odysseyai_internal');
  const isReleaseQa = query.get('utm_source') === 'release_qa';

  if (isReleaseQa || marker === '1') {
    internalForPage = true;
    try {
      browser.localStorage.setItem(INTERNAL_TRAFFIC_KEY, '1');
    } catch {
      // Keep the page-session label when browser storage is blocked.
    }
  } else if (marker === '0') {
    internalForPage = false;
    try {
      browser.localStorage.removeItem(INTERNAL_TRAFFIC_KEY);
    } catch {
      // A previously stored flag remains conservative if it cannot be cleared.
    }
  }

  let storedInternal = false;
  try {
    storedInternal = browser.localStorage.getItem(INTERNAL_TRAFFIC_KEY) === '1';
  } catch {
    // Analytics must not interrupt planning in restricted browsers.
  }

  return LOCAL_HOSTS.has(browser.location.hostname) || internalForPage || storedInternal
    ? 'internal'
    : 'unclassified';
};

// Preserve every SDK field, including its ingestion token and distinct ID.
// Only add a bounded, non-personal property; never drop or sample events here.
export const labelAnalyticsTraffic = (event) => event ? {
  ...event,
  properties: { ...event.properties, traffic_type: getAnalyticsTrafficType() },
} : event;
